import { CommunityChannelApi } from '@ps/api/community-channel';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * Soft-delete a channel message. The server flips the message
 * doc's `deleted` flag — the existing Firestore subscription
 * delivers the update and the bubble switches to the "This message
 * has been deleted." placeholder.
 */
export async function deleteChannelMessage({
  creatorId,
  channelId,
  messageId,
}: {
  creatorId: string;
  channelId: string;
  messageId: string;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerDeleteCommunityChannelMessage({
    sellerId: creatorId,
    channelId,
    messageId,
  });
}
